export default function ConstructorSeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Euclid's tools, two thousand years later
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Around 300 BCE, Euclid wrote down a set of rules for geometry that
        used only two tools: a straightedge (to draw a line between two
        points) and a compass (to draw a circle with a given center and
        radius). Out of these two moves came every construction in plane
        geometry — bisecting an angle, copying a length, drawing parallels,
        constructing perfect regular polygons. Constructor brings that
        toolkit to the screen. You have a virtual compass and a virtual
        straightedge. Your task is to construct specific geometric objects
        using only those two tools, in the right order.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        Why this still matters
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Compass-and-straightedge construction looks like history but it is
        the cleanest way to understand what's *possible* and what's *not*
        in geometry. You can construct an equilateral triangle, a regular
        pentagon, a regular 17-gon (Gauss, 1796). You CAN'T construct a
        regular 7-gon, you CAN'T trisect a general angle, you CAN'T square
        the circle. These impossibility proofs are 19th-century results in
        Galois theory and they only make sense once you understand what
        the constructible set actually is. Working through Constructor
        builds the geometric intuition for those proofs.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        The challenges
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Early levels are the classical warmups: bisect a segment, bisect an
        angle, drop a perpendicular from a point to a line. Middle levels
        ask for the standard polygons — equilateral triangle, square, regular
        hexagon. Late levels reach for the harder constructions — the
        golden ratio, the regular pentagon, the 17-gon's first step. Every
        puzzle is verified end-to-end: the test suite replays the canonical
        construction with small perturbations to confirm the geometry holds.
      </p>
    </>
  );
}
